import type { RunSummary } from "contracts/api/crawl/run-read.responses";
import { CRAWL_RUN_STATUS } from "contracts/enums/core";
import { runProgressLabel } from "../runs/runStagePresentation";

type ActiveRunSummary = {
  href: string;
  runId: string;
  canCancel: boolean;
  label: string;
  // Fleet-wide queue backlog, not this run's health — see isYeetWorkerStalled.
  backedUp: boolean;
  accessibleLabel: string;
};

/**
 * The top bar's one-line readout of the running scan. A run with maxPages 0 is
 * the optimistic placeholder written on scan start, before the backend has
 * minted the real run.
 */
export function activeRunSummary(
  websiteId: string,
  run: RunSummary | null,
  backedUp: boolean,
): ActiveRunSummary | null {
  if (!run) return null;
  const seconds = run.startedAt
    ? Math.max(0, Math.floor((Date.now() - run.startedAt.getTime()) / 1000))
    : null;
  const elapsed =
    seconds === null
      ? ""
      : seconds < 60
        ? `${seconds}s elapsed`
        : `${Math.floor(seconds / 60)}m elapsed`;
  // The placeholder has no counts yet; past that, the stage reading is the
  // same one the run list and run detail show.
  const status = run.maxPages === 0 ? "Starting scan" : runProgressLabel(run);
  return {
    href: `/w/${websiteId}/runs/${run.runId}`,
    runId: run.runId,
    canCancel: run.status === CRAWL_RUN_STATUS.RUNNING && run.maxPages > 0,
    label: elapsed ? `${status} - ${elapsed}` : status,
    backedUp,
    accessibleLabel: `Open active scan. ${status}${elapsed ? `; ${elapsed}` : ""}.`,
  };
}
